import "./App.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "./components/Shared/NavBar";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Footer from "./components/Shared/Footer/Footer";
import RequireAuth from "./components/Shared/RequireAuth";
import { Toaster } from "react-hot-toast";
import ResetPassword from "./Pages/ResetPassword";
import ErrorPage from "./Pages/ErrorPage";
import CursorEffect from "./components/AiHomePage/CursorEffect";
import AdminDashboardLayout from "./components/AiHomePage/Dashboard/AdminDashBoard/AdminDashboardLayout";
import AdminAuth from "./Pages/Seller/AdminAuth";
import UserEmailTemplate from "./components/AiHomePage/Dashboard/AdminDashBoard/UserEmailTemplate";
import CronSettingsForm from "./components/AiHomePage/Dashboard/AdminDashBoard/CronSettingsForm";
import EmailGenerator from "./components/AiHomePage/Dashboard/AdminDashBoard/EmailGenerator";

import EmailMerketingDash from "./components/AiHomePage/Dashboard/EmailMerketingDash/EmailMerketingDash";
import UserManagementEmailTemplate from "./components/AiHomePage/Dashboard/EmailMerketingDash/UserManagementEmailTemplate";
import EmailMarketingSMTPForm from "./components/AiHomePage/Dashboard/EmailMerketingDash/EmailMarketingSMTPForm";
import EmailAnalyticsDashboard from "./components/AiHomePage/Dashboard/EmailMerketingDash/EmailAnalyticsDashboard";

function App() {
  const location = useLocation();

  // Define paths where you don't want the NavBar and Footer
  const hideNavAndFooter =
    location.pathname === "/" ||
    location.pathname.startsWith("/user") ||
    location.pathname.startsWith("/admin");
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <div className="page-wrapper">
      <div className="cursor" />
      <div className="cursor-follower" />
      <CursorEffect />
      <Toaster />
      {/* {!hideNavAndFooter && <NavBar />} */}

      <Routes>
        <Route path="*" element={<ErrorPage />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/reset-password" element={<ResetPassword />}></Route>
        {/* Protected admin routes */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
               <AdminDashboardLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate replace to="email-marketing" />} />
          <Route path="email-templates" element={<UserEmailTemplate />}></Route>
          <Route path="generate-email" element={<EmailGenerator />}></Route>

          <Route
            path="cron-setting"
            element={<EmailMarketingSMTPForm />}
          ></Route>
          <Route
            path="email-marketing"
            element={<EmailMerketingDash />}
          ></Route>
          <Route
            path="user-email-marketing"
            element={<UserManagementEmailTemplate />}
          ></Route>
          <Route
            path="user-marketing-smpt"
            element={<EmailMarketingSMTPForm />}
          ></Route>
          <Route
            path="email-analytics"
            element={<EmailAnalyticsDashboard />}
          ></Route>
        </Route>
        <Route
          path="/"
          element={
            <RequireAuth>
              <AdminDashboardLayout />
            </RequireAuth>
          }
        >
          <Route index element={<EmailMerketingDash />} />
        </Route>
      </Routes>
      {/* {!hideNavAndFooter && <Footer />} */}
    </div>
  );
}

export default App;
